import { Dialog, DialogContent, Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useParams } from 'react-router';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import PublishChannelTableRow from './PublishChannelTableRow';
import { useGetPublishChannelByIdQuery } from 'src/graphql';
import { YOUTUBE_VIDEOS_TABLE_HEAD } from 'src/utils/tables-headers';
import { useState } from 'react';
import { useBoolean } from 'src/hooks/use-boolean';
import ReactPlayer from 'react-player';

type Props = {
  selected: string[];
  setSelected: any;
};
export default function PublishChannelTablePage({ selected, setSelected }: Props) {
  const { suggestedId } = useParams();
  const table = useTable();
  const showVideo = useBoolean();
  const [videoLink, setVideoLink] = useState();

  const start = table.page * table.rowsPerPage;
  const end = start + table.rowsPerPage;

  const handleSelectRow = (id: string) => {
    setSelected((prev: any) =>
      prev.includes(id) ? prev.filter((item: any) => item !== id) : [...prev, id]
    );
  };

  const { data, isLoading } = useGetPublishChannelByIdQuery({
    // offset: table.offset,
    // limit: table.rowsPerPage,
    id: suggestedId,
  });

  const allVideos = data?.fetchAllYoutubeVideosByChannelId?.videos || [];
  const count = allVideos.length;
  const paginatedVideos = allVideos.slice(start, end);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableContainer>
          <Scrollbar>
            <Table>
              <TableHeadCustom
                headLabel={YOUTUBE_VIDEOS_TABLE_HEAD}
                onSelectAllRows={(checked) => {
                  paginatedVideos?.map((row: any) => {
                    // handleSelectRow(row?.videoId);
                    if (!row?.isAdded) {
                      setSelected((prev: any) =>
                        checked
                          ? [...prev, row?.videoId]
                          : prev.filter((item: any) => item !== row?.videoId)
                      );
                    }
                  });
                }}
                tableOffset={table.page}
                numSelected={selected?.length}
              />
              <TableBody>
                {isLoading
                  ? [...Array(table.rowsPerPage)].map((i, index) => (
                      <TableSkeleton key={index} sx={{ height: 80 }} />
                    ))
                  : paginatedVideos?.map((row) => (
                      <PublishChannelTableRow
                        key={row.videoId}
                        row={row}
                        selected={selected.includes(row.videoId)}
                        onSelectRow={() => handleSelectRow(row.videoId)}
                        showVideo={showVideo}
                        setVideoLink={setVideoLink}
                      />
                    ))}
              </TableBody>
            </Table>
          </Scrollbar>
        </TableContainer>
        {data && (
          <TablePaginationCustom
            count={count}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        )}
      </Grid>
      {/* Show Video Link */}
      {showVideo.value && (
        <Dialog maxWidth="md" open={showVideo.value} onClose={showVideo.onFalse}>
          <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
            <ReactPlayer url={videoLink} controls playing />
          </DialogContent>
        </Dialog>
      )}
    </Grid>
  );
}
